// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_cQD","cls2":"AuthorHeader-cls2_3Np AuthorHeader-cls1_cQD","variant-dense":"AuthorHeader-variant-dense_ifY"};